import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-module-decorators';
import { updateProduct } from '@/api/products';
import HelpText from '@/components/HelpText/index.vue';
import Tinymce from '@/components/Tinymce/index.vue';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.loading = false;
    this.rules = {};
    this.inputTagVisible = false;
    this.inputTagValue = '';
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  activated() {}
  handleProductTypeChange() {
    this.$emit('updated', this.formData);
  }
  async saveForm() {
    this.loading = true;
    try {
      const response = await updateProduct(this.formData.id, this.formData);
      this.formData = response;
      this.$notify({
        title: 'Success',
        message: 'saved',
        type: 'success',
        duration: 2000
      });
      this.$emit('updated', this.formData);
    } catch (err) {
      this.$notify.error(err.toString());
    } finally {
      this.loading = false;
    }
  }
  resetForm() {
    this.$refs.formData.resetFields();
  }
  showTagInput() {
    this.inputTagVisible = true;
    this.focusTagInput();
  }
  focusTagInput() {
    this.$nextTick(() => {
      this.$refs.saveTagInput.$refs.input.focus();
    });
  }
  handleTagInputConfirm(event) {
    const inputValue = this.inputTagValue;
    if (inputValue) {
      let tags = [];
      if (this.formData.tags) {
        tags = this.formData.tags.split(',');
      }
      // push if not exist
      if (tags.indexOf(inputValue) === -1) {
        tags.push(inputValue);
      } else {
        this.$message({
          showClose: true,
          message: inputValue + ' already exist!',
          type: 'warning'
        });
      }
      this.formData.tags = tags.join(',');
    }
    this.inputTagValue = '';
    // if entered
    if (event.keyCode && event.keyCode === 13) {
      this.focusTagInput();
    } else {
      this.inputTagVisible = false;
    }
  }
  handleTagClose(tag) {
    const tags = this.formData.tags.split(',');
    this.formData.tags = tags.splice(tags.indexOf(tag), 1).join(',');
  }
};
__decorate([Prop({
  default: {}
})], default_1.prototype, "formData", void 0);
__decorate([Prop({
  default: false
})], default_1.prototype, "isEdit", void 0);
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: 'ProductAdvanceTab',
  components: {
    HelpText,
    Tinymce
  }
})], default_1);
export default default_1;